import React from "react";
import LongShortChart from "../Charts/LongShortChart";

const ResultsByOpenHourChart = ({ data }) => {
  const labels = data && data?.duration;
  const seriesData =
    data && data?.average_profit_loss.map((value) => Number(value.toFixed(2)));

  const name = "P&L";

  return (
    <>
      <LongShortChart labels={labels} seriesData={seriesData} name={name} />
    </>
  );
};

export default ResultsByOpenHourChart;
